import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Tabs as MuiTabs } from '@material-ui/core';

var Tabs = function Tabs(_ref) {
  var a11yLabel = _ref.a11yLabel,
      children = _ref.children,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(MuiTabs, _extends({
    "aria-label": a11yLabel
  }, e2e && {
    'data-e2e': e2e
  }, {
    variant: "scrollable",
    onChange: dsOnChange,
    TabScrollButtonProps: {
      disabled: false
    },
    textColor: "secondary"
  }, value !== undefined && {
    value: value
  }), children);
};

export default Tabs;

try {
  Tabs.__docgenInfo = {
    description: '',
    displayName: 'Tabs',
    methods: [],
    props: {
      a11yLabel: {
        defaultValue: null,
        description: 'ARIA label. Necessary for accessibility.',
        name: 'a11yLabel',
        required: true,
        type: {
          name: 'string'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<unknown>, value: any) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      children: {
        defaultValue: null,
        description: 'The content of the component.',
        name: 'children',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      value: {
        defaultValue: null,
        description: 'The value of the currently selected `Tab`.\n' + "If you don't want any selected `Tab`, you can set this property to `false`.",
        name: 'value',
        required: false,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map